import { css } from "@emotion/css";
import { Results } from "./Results";
import { useState } from "react";
import { FloatInput } from "./FloatInput";
import { Button } from "./Button";
import { generateSlug } from "random-word-slugs";
import { makePointLaps } from "./makePointLaps";
import { pluralize } from "./pluralize";
import { RaceData } from "./types";

const slugify = () => {
  let returnValue = "";

  while (!returnValue) {
    const possibleValue = generateSlug(3, {
      format: "title",
    });

    if (possibleValue.length < 26)
      returnValue = possibleValue;
  }

  return returnValue;
};

export const GongShowCalculator = () => {
  const [seedValue, setSeedValue] = useState<string>("");
  const [laps, setLaps] = useState<number>();
  const [sprints, setSprints] = useState<number>();
  const [raceData, setRaceData] = useState<RaceData>({
    pointLaps: [],
    bonusIdx: 0,
    missingSprints: false,
  });

  const validations: {
    display: boolean;
    message: string;
  }[] = [];

  if (typeof sprints === "number" && sprints > 32)
    validations.push({
      display: true,
      message:
        "this app currently only supports 32 or fewer sprints",
    });
  if (typeof sprints === "number" && sprints < 1)
    validations.push({
      display: true,
      message: "need at least one sprint",
    });
  if (typeof laps === "number" && laps > 255)
    validations.push({
      display: true,
      message:
        "this app currently only supports 255 or fewer laps",
    });
  if (typeof laps === "number" && laps < 1)
    validations.push({
      display: true,
      message: "need at least one lap",
    });

  const handleMakePointLapsClick = () => {
    const seed = seedValue ? seedValue : slugify();
    if (seed !== seedValue) setSeedValue(seed);

    const s = sprints ?? 5;
    if (s !== sprints) setSprints(s);

    const l = laps ?? 25;
    if (l !== laps) setLaps(l);

    setRaceData(makePointLaps(s, l, seed));
  };

  return (
    <div
      className={css(`
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 100%;
            box-sizing: border-box;

            .float-lockup {
              display: flex;
              width: 100%;
              gap: 10px;
              align-items: center;
              box-sizing: border-box;
            }
          `)}
    >
      <div className="float-lockup">
        <FloatInput
          placeholder="Seed Phrase"
          value={seedValue}
          onChange={setSeedValue}
        />
        <Button
          title="Generate"
          onClick={() => setSeedValue(slugify())}
        />
      </div>
      <div className="float-lockup">
        <FloatInput
          placeholder="Laps"
          value={
            typeof laps === "number" && !isNaN(laps)
              ? laps.toString()
              : ""
          }
          onChange={(val) =>
            setLaps(
              parseInt(val.match(/\d*/)?.join("") ?? ""),
            )
          }
        />
        <FloatInput
          placeholder="Sprints"
          value={
            typeof sprints === "number" && !isNaN(sprints)
              ? sprints.toString()
              : ""
          }
          onChange={(val) =>
            setSprints(
              parseInt(val.match(/\d*/)?.join("") ?? ""),
            )
          }
        />
      </div>
      {pluralize(
        validations
          .filter((v) => v.display)
          .map((v) => v.message),
      )}
      <Button
        title="Make Point Laps"
        disabled={validations.length > 0}
        onClick={handleMakePointLapsClick}
      />
      <Results raceData={raceData} />
    </div>
  );
};
